<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <!--Modal-->
          <b-modal
            v-if="resetPassword"
            v-model="resetPassword"
            class="aligned"
            title="Please Reset Password"
            hide-footer
            @ok="resetPassword = false"
          >
            <p>Password needs to be at least 8 characters long. It has to have at least <br>1 upper case character, 1 lower case character, 1 number <br> and 1 special character @#%!$</p>
            <form @submit.prevent="changePassword">
              <div class="resetModal">
                <b-alert
                  variant="danger"
                  :show="error != ''"
                >
                  {{ error }}
                </b-alert>
                <input
                  v-model="password"
                  type="password"
                  class="form-control login"
                  required
                  placeholder="Password"
                >
              </div>
              <button
                type="submit"
                class="btn btn-primary login center-block modalSubmit"
              >
                Reset Password
              </button>
            </form>
          </b-modal>
          <!--Modal-->
        </div>
      </div>
    </div>
    <footer class="login-footer">
      <img
        src="static/img/labs_logo.svg"
        class="labs-logo login center-block"
        alt="labs-img"
      >
    </footer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ResetPassword',
  data () {
    return {
      resetPassword: true,
      password: '',
      error: ''
    }
  },
  computed: {
    ...mapGetters([
      'username'
    ])
  },
  methods: {
    close: function () {
      this.password = ''
    },
    changePassword (event) {
      let token = this.$route.query.token
      const {password} = this
      /* Making API call to send email */
      this.$store.dispatch('changePassword', {password, reset_token: token})
        .then(response => {
          this.$router.push('/login')
        })
        .catch((error) => {
          this.error = error.message
        })
      this.myModal = false
      this.close()
    }
  }
}
</script>
